export const FIREBASE_CONFIG  = {
    // Initialize Firebase
    apiKey: "AIzaSyCnJKIDx5E0GKYvzYB34RbyeBBzl_JJgmw",
    authDomain: "eating-healthy.firebaseapp.com",
    databaseURL: "https://eating-healthy.firebaseio.com",
    projectId: "eating-healthy",
    storageBucket: "eating-healthy.appspot.com",
    messagingSenderId: "46906765196"
  };



// WEBPACK FOOTER //
// ./src/app/app.firebase.config.ts